import React from 'react';

export default function LogoMark({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" style={{ flexShrink: 0 }}>
      <defs>
        <linearGradient id="logoBarGrad" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#00a884" />
          <stop offset="100%" stopColor="#00d4aa" />
        </linearGradient>
        <linearGradient id="logoPulseGrad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#5eead4" />
          <stop offset="100%" stopColor="#ffffff" />
        </linearGradient>
      </defs>
      <rect width="100" height="100" rx="22" fill="#0a0f1e" />
      <rect x="16" y="58" width="12" height="26" rx="3" fill="url(#logoBarGrad)" />
      <rect x="34" y="46" width="12" height="38" rx="3" fill="url(#logoBarGrad)" />
      <rect x="52" y="34" width="12" height="50" rx="3" fill="url(#logoBarGrad)" />
      <rect x="70" y="22" width="12" height="62" rx="3" fill="url(#logoBarGrad)" />
      <polyline
        points="10,52 30,52 38,38 46,66 54,44 60,52 90,52"
        fill="none"
        stroke="url(#logoPulseGrad)"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
